/* eslint-disable simple-import-sort/imports */
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
	closeWorkerInsightDetails,
	fetchWorkerInsightDetails,
} from "../slices/worker-insight-report-slice";
import {WorkerInsightReportSliceStateTypes, WorkerInsightRootState} from "../slices/insight-report-types";
import {
	fetchSkills,
	getSkillPriorities,
} from "../../skills/store/skills-slice";
import { fetchWorkerProfile } from "../../workers/store/manage-workers-slice";

const useWorkerDetailsInsightController = ({
	workerId,
}: {
	workerId: string;
}) => {
	const dispatch = useDispatch();

	const workerInsightReportData = useSelector(
		(state: WorkerInsightRootState) =>
			state.workerInsightReportData.workerInsightReportData
	);
	const workerInsightReportDetailsData = useSelector(
		(state: WorkerInsightRootState) =>
			state.workerInsightReportData.workerInsightDetailsData
	);
	const fetchWorkerInsightDetailsStatus = useSelector(
		(state: WorkerInsightRootState) =>
			state.workerInsightReportData?.fetchWorkerInsightDetails?.status
	);

	const isSkillPriorityEnabled = useSelector(
		(state: any) => state.user.userData.skillPriorityEnabled
	);

	const jobSkillLevelMapping = useSelector(
		(state: any) => state.user.userData.jobSkillLevelMapping
	)

	const allSkillLevels = useSelector(
		(state: WorkerInsightRootState) =>
			state.workerInsightReportData.skillsLevelLegendsData
	);


	useEffect(() => {
		if (workerId) {
			//dispatch(fetchSkills());
			dispatch(fetchWorkerProfile(workerId));
			dispatch(fetchWorkerInsightDetails(workerId));
		}
	}, [workerId, isSkillPriorityEnabled, dispatch]);

	return [
		{
			allSkillLevels,
			workerInsightReportData,
			workerInsightReportDetailsData,
			fetchWorkerInsightDetailsStatus,
			jobSkillLevelMapping,
		},
		{
			dispatch,
			closeWorkerInsightDetails,
		},
	];
};

export default useWorkerDetailsInsightController;
